import React, { useEffect } from 'react';

const WizardStepWrapper = ({ children }) => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return <div className="wizard-step">{children}</div>;
};

export default WizardStepWrapper;